export default {
  welcomes: 'Welcome to the backstage, please select other menu bars on the left',
  support: 'Support',
  gopaylabel: `Providing fast, convenient and safe  payment services`,
  rules: {
    username: 'Account cannot be empty！',
    password: 'password can not be empty！',
    code: 'verification can not be empty！',
    form: {
      assist: 'assist',
      system: 'Customer management system',
      Login: 'Login',
      UserName: 'User Name',
      Password: 'Password',
      verification: 'Google verification Code',
      Forgotpassword: 'Forgot password?',
      btnlogin: 'Login',
      label:
        'Committed to providing fast, convenient and extremely secure electronic payment services. Operating 24/7.',
      fast_lable: 'Providing fast, convenient and safe payment services',
      accountName: 'Account Name',
      password_fast: 'password',
      GoogleCode: 'Google verification code'
    }
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/en/login.js